import { useOktaAuth } from '@okta/okta-react';
import { datadogRum } from '@datadog/browser-rum';
import { clearUserStorageItems } from '@components/logout/ProfileBadge';

export const useLogoutHook = () => {
  const { oktaAuth } = useOktaAuth();

  const handleLogout = async () => {
    clearUserStorageItems();
    datadogRum.stopSessionReplayRecording();
    if (oktaAuth.signOut) {
      await oktaAuth.signOut();
    }
  };

  return { handleLogout };
};
